module.exports = __webpack_public_path__ + "img/summary_avatar.3bcb0243.png";